import {
  listContextQuery,
  RECENT_RECIPES_LIMIT,
  useAwaitingFirstSync,
  useRecipeSummaries,
} from '@platewell/query';
import { FirstSyncEmpty } from '../components/first-sync-empty.js';
import { RecipeCard } from '../components/recipe-card.js';

export function RecentRecipesPage() {
  const context = { kind: 'recent' } as const;
  const recipes = useRecipeSummaries(listContextQuery(context));
  const awaitingFirstSync = useAwaitingFirstSync();

  return (
    <>
      <div className="row" style={{ marginBottom: 18 }}>
        <h1>Recently Added</h1>
        <span className="spacer" />
        <span className="hint">Newest {RECENT_RECIPES_LIMIT} recipes</span>
      </div>

      {recipes.length === 0 && awaitingFirstSync ? (
        <FirstSyncEmpty />
      ) : recipes.length === 0 ? (
        <div className="empty">
          <h2>No recipes yet</h2>
          <p className="hint">Recipes you import or add will show up here, newest first.</p>
        </div>
      ) : (
        <div className="grid">
          {recipes.map((recipe) => (
            <RecipeCard key={recipe.id} recipe={recipe} context={context} />
          ))}
        </div>
      )}
    </>
  );
}
